module.exports = __webpack_public_path__ + "static/media/BillingDetails.f34dc654.svg";